// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_FindAddressResult from "../Restaumatic.Analytics.Types.FindAddressResult/index.js";
import * as Restaumatic_Analytics_Types_Origin from "../Restaumatic.Analytics.Types.Origin/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Analytics_Types_Origin.eqOrigin);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Analytics_Types_FindAddressResult.eqFindAddressResult);
var originIsSymbol = {
    reflectSymbol: function () {
        return "origin";
    }
};
var resultIsSymbol = {
    reflectSymbol: function () {
        return "result";
    }
};
var FindAddressIsSymbol = {
    reflectSymbol: function () {
        return "FindAddress";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var FindAddress = function (x) {
    return x;
};
var toFillFormTypeFindAddress = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeFindAddress_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldFindAddress = function (dictHasField) {
    return dictHasField;
};
var eqFindAddress = {
    eq: function (x) {
        return function (y) {
            return eq(x.origin)(y.origin) && eq1(x.result)(y.result);
        };
    }
};
var genericFindAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showFindAddress = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFindAddress)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(originIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(resultIsSymbol)(Restaumatic_Analytics_Types_FindAddressResult.showFindAddressResult))(Restaumatic_Analytics_Types_Origin.showOrigin))))(FindAddressIsSymbol))
};
var unscrambleDecodeFindAddress = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFindAddress)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(originIsSymbol)(Restaumatic_Analytics_Types_Origin.unscrambleDecodeOrigin)(/* #__PURE__ */ Unscramble.decodeRecordCons(resultIsSymbol)(Restaumatic_Analytics_Types_FindAddressResult.unscrambleDecodeFindAddressResult)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeFindAddress = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFindAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(FindAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(resultIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Analytics_Types_FindAddressResult.encodeFindAddressResult)))(originIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Analytics_Types_Origin.encodeOrigin))))))
};
var decodeFindAddress = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFindAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(FindAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(resultIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Analytics_Types_FindAddressResult.decodeFindAddressResult))())(originIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Analytics_Types_Origin.decodeOrigin))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    FindAddress,
    genericFindAddress,
    eqFindAddress,
    showFindAddress,
    encodeFindAddress,
    decodeFindAddress,
    unscrambleDecodeFindAddress,
    toFillFormTypeFindAddress,
    hasFieldFindAddress,
    newtypeFindAddress_
};
